export const itCodeRequestTypes = [
  { label: "Cấp mới", value: "provide" },
  { label: "Hủy EPRS", value: "evict" },
];

export const approverType = {
  approver: 1,
  itlead: 2,
  ithead: 3,
  assignee: 4,
};
